<template>
  <div v-if="booting" class="portal-boot">
    <div class="portal-boot__spinner" />
  </div>
  <div v-else-if="maintenanceMode === null" class="portal-boot">
    <div class="portal-boot__spinner" />
  </div>
  <MaintenancePage v-else-if="maintenanceMode" />
  <RouterView v-else />
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import MaintenancePage from '@/components/MaintenancePage.vue'
import { usePortalConfigStore } from '@/stores/portalConfigStore'
import { shouldFetchPortalConfig } from '@/utils/portalHost'

const booting = ref(true)
const maintenanceMode = ref<boolean | null>(null)
const portalConfig = usePortalConfigStore()

onMounted(async () => {
  if (!shouldFetchPortalConfig()) {
    portalConfig.resetForGenericHost()
  } else {
    await portalConfig.loadForCurrentHost()
  }
  booting.value = false

  fetch('/maintenance.json')
    .then((r) => (r.ok ? r.json() : { enabled: false }))
    .then((data: { enabled?: boolean }) => {
      maintenanceMode.value = Boolean(data?.enabled)
    })
    .catch(() => {
      maintenanceMode.value = false
    })
})
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}

.portal-boot {
  min-height: 100vh;
  width: 100%;
  background: var(--va-background-primary, #f5f5f5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.portal-boot__spinner {
  width: 2.5rem;
  height: 2.5rem;
  border: 2px solid var(--va-primary, #154ec1);
  border-top-color: transparent;
  border-radius: 50%;
  animation: portal-boot-spin 0.8s linear infinite;
}

@keyframes portal-boot-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
